import React from 'react';
import { Loader } from 'common/components/Loader';
import { LoaderType } from 'common/components/Loader/types';
import { useWidth } from 'common/hooks';

type Props = {
    children: any;
    isLoading: boolean;
};

const SVGMobile = () => (
    <>
        <rect x="0" y="0" rx="5" ry="5" width="240" height="33" />
        <rect x="0" y="40" rx="5" ry="5" width="180" height="33" />
        <rect x="0" y="100" rx="5" ry="5" width="195" height="13" />
        <rect x="0" y="130" rx="5" ry="5" width="195" height="13" />
        <rect x="0" y="180" rx="8" ry="8" width="120" height="20" />
        <rect x="130" y="180" rx="8" ry="8" width="90" height="20" />
        <rect x="0" y="250" rx="5" ry="5" width="240" height="380" />
    </>
);

const SVGTablet = () => (
    <>
        <rect x="0" y="0" rx="5" ry="5" width="420" height="33" />
        <rect x="0" y="40" rx="5" ry="5" width="280" height="33" />
        <rect x="0" y="100" rx="5" ry="5" width="195" height="13" />
        <rect x="0" y="130" rx="5" ry="5" width="195" height="13" />
        <rect x="0" y="180" rx="8" ry="8" width="120" height="20" />
        <rect x="130" y="180" rx="8" ry="8" width="90" height="20" />
        <rect x="0" y="250" rx="5" ry="5" width="280" height="380" />
    </>
);

const SVG = () => (
    <>
        <rect x="20" y="15" rx="5" ry="5" width="280" height="380" />
        <rect x="361" y="20" rx="5" ry="5" width="420" height="33" />
        <rect x="361" y="60" rx="5" ry="5" width="315" height="33" />
        <rect x="361" y="120" rx="5" ry="5" width="195" height="13" />
        <rect x="361" y="150" rx="5" ry="5" width="195" height="13" />
        <rect x="361" y="210" rx="8" ry="8" width="130" height="20" />
        <rect x="515" y="210" rx="8" ry="8" width="110" height="20" />
    </>
);

const loaderConfig: {
    [key: string]: { height: number; width: number; render: any };
} = {
    xs: {
        height: 650,
        width: 240,
        render: SVGMobile,
    },
    sm: {
        height: 650,
        width: 450,
        render: SVGTablet,
    },
    md: {
        height: 500,
        width: 800,
        render: SVG,
    },
    lg: {
        height: 500,
        width: 800,
        render: SVG,
    },
    xl: {
        height: 500,
        width: 800,
        render: SVG,
    },
};

const ProductLoader: React.FC<Props> = ({ children, isLoading }) => {
    const current = useWidth();
    const { height, width, render } = loaderConfig[current];

    return (
        <Loader
            isLoading={isLoading}
            height={height}
            width={width}
            speed={2}
            loaderType={LoaderType.CUSTOM_SVG}
            render={render}
        >
            {children}
        </Loader>
    );
};

export default ProductLoader;
